export default "__VITE_ASSET__ChA7b3AC__"